(() => {
  if (window.mkpWallLoader) return;
  window.mkpWallLoader = true;
  let loading;
  const update = (preview, selection) => {
    if (!preview.variantIds) {
      const catalog = JSON.parse(preview.querySelector('[data-wall-catalog]').textContent);
      preview.variantIds = new Set(catalog.flatMap(item => item.variantIds));
    }
    preview.hidden = !selection.eligible || !preview.variantIds.has(String(selection.variantId));
    if (preview.hidden && preview.querySelector('dialog').open) preview.querySelector('dialog').close();
  };
  document.addEventListener('mkp:selection-change', event => {
    const preview = event.target.closest('product-info')?.querySelector('mkp-wall-preview');
    if (preview) update(preview, event.detail);
  });
  document.querySelectorAll('mkp-wall-preview').forEach(preview => {
    const config = document.getElementById('MainProduct-' + preview.dataset.sectionId)?.querySelector('[data-mkp-frame-config]');
    if (config?.mkpSelection) update(preview, config.mkpSelection);
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-wall-open]');
    const preview = button?.closest('mkp-wall-preview');
    if (!preview || preview.hidden || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      loading ||= import(preview.dataset.previewUrl).catch(error => { loading = null; throw error; });
      await loading;
      if (preview.isConnected) await preview.open();
    } catch {
      const copy = JSON.parse(preview.querySelector('[data-wall-copy]').textContent);
      preview.querySelector('[data-wall-status]').textContent = copy.failed;
      const dialog = preview.querySelector('dialog');
      if (!dialog.open) dialog.showModal();
      if (!customElements.get('mkp-wall-preview')) preview.querySelector('[data-wall-close]').onclick = () => dialog.close();
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
